<style scoped>

</style>
<template>
    <div>
        <Modal
            v-model="showing"
            title="测试环境登录"
            >
            <Form ref="form" :model="params" :rules="rules">
                <FormItem prop="email">
                    <i-input v-model="params.email" @on-enter="login" icon="md-mail" placeholder="用户名..."></i-input>
                </FormItem>
                <FormItem prop="password">
                    <i-input type="password" v-model="params.password" @on-enter="login" icon="md-key" placeholder="密码..."></i-input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" long @click="login" :loading="loading">登录</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showing: false,
                loading: false,
                params: {
                    email: '',
                    password: ''
                },
                rules: {
                    email: [
                        { required: true, message: '用户名不能为空', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '密码不能为空', trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            //
        },
        mounted(){
            this.addEvents();
        },
        methods: {
            addEvents(){
                eventHub.$on('show-dev-login', ()=>{
                    this.showing = true;
                });
            },
            login(){
                this.$refs.form.validate((valid) => {
                    if(valid){
                        this.loading = true;
                        Util.ajax.get(Util.api.dev_login, {
                            params: this.params
                        }).then((response)=>{
                            return response.data;
                        }).then((res)=>{
                            if(res.code === 1){
                                this.$Message.success('登录成功');
                                window.location.reload();
                            }else{
                                this.$Modal.warning({title: '错误', content: res.msg});
                            }
                        }).catch((e)=>{
                            this.$Modal.warning({title: '错误', content: e.message});
                        }).finally(()=>{
                            this.loading = false;
                        });
                    }
                })
            }
        }
    }
</script>
